import { AnalyticsAction } from '@/config/analytics';

const footerItems = [
  {
    label: 'API Portal',
    field: 'apiPortalLink',
    url: '',
    analytics: AnalyticsAction.LC_api_portal,
    show: false,
  },
  {
    label: 'Contact Us',
    field: 'contactUs',
    url: '/contact-us',
    analytics: AnalyticsAction.LC_about_us,
    show: true,
  },
  {
    label: 'About Us',
    field: 'aboutUs',
    url: '/about-us',
    analytics: AnalyticsAction.LC_about_us,
    show: true,
  },
  {
    label: 'Terms of Use',
    field: 'termsAndConditions',
    url: '/terms-of-use',
    analytics: AnalyticsAction.LC_terms_of_use,
    show: true,
  },
  {
    label: 'Privacy Policy',
    field: 'privacyPolicy',
    url: '/privacy-policy',
    analytics: AnalyticsAction.LC_privacy_policy,
    show: true,
  },
];

export { footerItems };
